<section class="footer mt-5">
  <div class="container">
    <div class="footer-content bg-secondary pt-lg-5 px-lg-5 p-2 mb-3">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 my-3 logo">
            <div class="footer-logo">
              <a routerLink="/"
                ><img src="assets/images/logo.svg" alt="Shuwier Logo" class="w-100 mb-5"
              /></a>
            </div>
          </div>
          <div class="col-lg-9 my-3">
            <div class="row footer-wrapper">
              <!-- Categories -->
              <div class="col-md-3 col-sm-3 col-6 my-3">
                <h6 class="mb-3 fw-semibold text-black">Categories</h6>
                @for (item of Categories; track $index) {
                  <p class="mb-2 fw-semibold category-link item" (click)="navigateToCategory(item)">
                    {{ item.name }}
                  </p>
                }
              </div>
              <!-- Company Links -->
              <div class="col-md-3 col-sm-3 col-6 my-3">
                <h6 class="mb-3 fw-semibold text-black">Company</h6>

                @for (item of companyLinks; track $index) {
                  <p class="mb-2 fw-semibold">
                    <a [routerLink]="item.route" class="text-decoration-none text-dark item">
                      {{ item.label }}
                    </a>
                  </p>
                }
              </div>
              <!-- Quick Links -->
              <div class="col-md-3 col-sm-3 col-6 my-3">
                <h6 class="mb-3 fw-semibold text-black">Quick links</h6>
                @for (item of quickLinks; track $index) {
                  <p class="mb-2 fw-semibold">
                    <a [routerLink]="item.route" class="text-decoration-none text-dark item">
                      {{ item.label }}
                    </a>
                  </p>
                }
              </div>
              <!-- Social Media Links -->
              <div class="col-md-3 col-sm-3 col-6 my-3">
                <h6 class="mb-3 fw-semibold text-black">Follow us</h6>
                <ul class="d-flex gap-1 list-unstyled ps-0 flex-wrap">
                  @for (item of mergedSocialLinks; track $index) {
                    @if (item.link !== null) {
                      <li>
                        <a href="{{ item.link }}" target="_blank">
                          <img
                            src="assets/images/{{ item.icon }}"
                            alt="{{ item.link }} Icon"
                            width="24"
                            height="24"
                          />
                        </a>
                      </li>
                    }
                  }
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="copyright pt-2">
              <div class="row align-items-center d-flex">
                <div class="col-6">
                  <p class="d-flex align-items-center gap-1">
                    <img src="assets/images/copyright.svg" alt="" /> 2026 All Rights Reserved.
                  </p>
                </div>
                <!-- <div class="col-6 text-end">
                  <button class="btn p-0 fw-semibold" type="button">
                    <span>العربية</span
                    ><img src="assets/images/icons/lang-footer.svg" alt="" class=" " />
                  </button>
                  <button class="btn p-1 fw-semibold" type="button">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0ZM12 1.5C9.21523 1.5 6.54451 2.60625 4.57538 4.57538C2.60625 6.54451 1.5 9.21523 1.5 12C1.5 14.7848 2.60625 17.4555 4.57538 19.4246C6.54451 21.3938 9.21523 22.5 12 22.5C14.7848 22.5 17.4555 21.3938 19.4246 19.4246C21.3938 17.4555 22.5 14.7848 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM17.961 8.013C18.0165 8.17937 18.0119 8.35991 17.948 8.52324C17.8841 8.68656 17.7651 8.82235 17.6115 8.907L17.487 8.961L13.5 10.29V14.1285L14.961 18.513C15.0165 18.6794 15.0119 18.8599 14.948 19.0232C14.8841 19.1866 14.7651 19.3224 14.6115 19.407L14.487 19.461C14.3206 19.5165 14.1401 19.5119 13.9768 19.448C13.8134 19.3841 13.6776 19.2651 13.593 19.1115L13.539 18.987L12.039 14.487L12 14.25L11.961 14.487L10.461 18.987C10.4027 19.1657 10.2794 19.316 10.1156 19.4081C9.95179 19.5003 9.75934 19.5275 9.57636 19.4845C9.39339 19.4415 9.23324 19.3314 9.12761 19.1759C9.02198 19.0204 8.97858 18.8309 9.006 18.645L9.039 18.513L10.5 14.124V10.29L6.513 8.961C6.33431 8.90271 6.18401 8.77945 6.09188 8.61562C5.99974 8.45179 5.97248 8.25934 6.01549 8.07636C6.0585 7.89339 6.16864 7.73324 6.32411 7.62761C6.47958 7.52198 6.66905 7.47858 6.855 7.506L6.987 7.539L11.3745 9H12.624L17.013 7.539C17.2016 7.47629 17.4073 7.49099 17.5851 7.57986C17.7628 7.66874 17.898 7.82452 17.961 8.013ZM12 4.5C12.3978 4.5 12.7794 4.65804 13.0607 4.93934C13.342 5.22064 13.5 5.60218 13.5 6C13.5 6.39782 13.342 6.77936 13.0607 7.06066C12.7794 7.34196 12.3978 7.5 12 7.5C11.6022 7.5 11.2206 7.34196 10.9393 7.06066C10.658 6.77936 10.5 6.39782 10.5 6C10.5 5.60218 10.658 5.22064 10.9393 4.93934C11.2206 4.65804 11.6022 4.5 12 4.5Z"
                        fill="#333333"
                      />
                    </svg>
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
